<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2023-07-10 17:41:58
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-04 16:48:34
-->
<template>
	<el-select
		v-model="searchValue"
		class="select-box"
		filterable
		clearable
		:collapse-tags="collapseTags"
		:multiple-limit="10"
		:multiple="multiple"
		:placeholder="placeholder"
		@change="changeSelect"
		v-loadMore="loadMore"
	>
		<el-option v-for="item in list" :key="item.id" :label="item.tagName" :value="item.id" />
		<div class="align-center bottom pt-8 pb-8 yx-color-text-secondary fz-12" v-if="!noMore">
			{{ noMore ? '到底了~' : '加载中' }}
		</div>
	</el-select>
</template>

<script>
import { tagsList } from '@/api/shopManage';
import { getTagList } from '@/api/tagManagement'
export default {
	props: {
		multiple: {
			type: Boolean,
			default: true,
		},
		value: {
			type: [String, Array],
		},
		collapseTags: {
			type: Boolean,
			default: false,
		},
		// 0商品标签 1达人标签 2内容/素材标签
		type: {
			type: [Number, String],
			default: '0',
		},
		// 0商品标签 1达人标签
		placeholder: {
			type: String,
			default: '请选择',
		},
	},
	watch: {
		value(val) {
			this.searchValue = val ? val : this.multiple ? [] : '';
		},
	},
	data() {
		return {
			list: [],
			searchValue: '',
			pageInfo: {
				page_index: 1,
				page_size: 100,
			},
			total: '0',
			noMore: true,
		};
	},
	created() {
		this.getList();
	},
	methods: {
		async getList(e = '', isNext = false) {
			let api = {
				0: tagsList,
				1: tagsList,
				2: getTagList
			}
			let params = {
				0: { ...this.pageInfo, tag_name: e, type: this.type },
				1: { ...this.pageInfo, tag_name: e, type: this.type },
				2: {pageIndex: this.pageInfo.page_index,pageSize: this.pageInfo.page_size,tagName: e, appType: 1}
			}
			const {
				code,
				data: { list = [], page = {} },
			} = await api[+this.type](params[+this.type]);
			if (code !== 0) return;
			this.loading = false;
			this.total = page.item_total || page.pageTotal;
			this.list = isNext ? this.list.concat(list) : list;
		},
		loadMore() {
			let num = Math.ceil(this.total / this.pageInfo.page_size);
			if (num <= this.pageInfo.page_index) return (this.noMore = true);
			this.noMore = false;
			this.pageInfo.page_index++;
			this.getList(this.searchValue, 1);
		},
		changeSelect(e) {
			this.$emit('input', e);
			this.$emit('change', e);
		},
		reset() {
			this.searchValue = '';
		},
	},
};
</script>
<style lang="less" scoped>
.bottom {
	border-top: 1px solid #ddd;
}
</style>
